import { APIError } from "../../sdk/api"
import ErrorToastStyles from "./error-toast.module.css"
import React from "react"
import { useTranslation } from "react-i18next"

type ErrorToastProps = {
    error: APIError
}

const ErrorToast = ({ error }: ErrorToastProps) => {
    const { t, i18n } = useTranslation("shared")

    return (
        <div>
            {error.code && i18n.exists(`shared:${error.code.replace(":", "_")}`)
                ? t(error.code.replace(":", "_"), { ...error.detail })
                : error.msg || t("generic_error")}
            {error.id && (
                <>
                    <br />
                    <span className={ErrorToastStyles.code}>
                        {t("error_code")} <code>{error.id}</code>
                    </span>
                </>
            )}
        </div>
    )
}

export default ErrorToast
